import { useTrans } from "@/translations";

import { BUILDING_LIST_COLUMNS } from "../constants";
import type { BuildingColumnKey, BuildingListRow, SortDir } from "../types";
import { ColumnHeaderView } from "./columnHeaderView";
import { RowView } from "./rowView";

type Props = {
  sortKey: BuildingColumnKey;
  sortDir: SortDir;
  onSort: (key: BuildingColumnKey) => void;
  rows: BuildingListRow[];
  onSelectRow: (row: BuildingListRow) => void;
};

export const TableView: React.FC<Props> = ({
  sortKey,
  sortDir,
  onSort,
  rows,
  onSelectRow,
}) => {
  const { t } = useTrans();
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[720px] border-collapse text-[13px]">
        <thead>
          <tr>
            {BUILDING_LIST_COLUMNS.map((column) => (
              <ColumnHeaderView
                key={column.key}
                column={column}
                sortKey={sortKey}
                sortDir={sortDir}
                onSort={onSort}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <RowView key={row.terminalId} row={row} onSelectRow={onSelectRow} />
          ))}
          {!rows.length && (
            <tr>
              <td
                colSpan={BUILDING_LIST_COLUMNS.length}
                className="text-grey6 py-[24px] text-center"
              >
                {t("portfolioPage:noBuildingsFound")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
